import Axios from 'axios';
import React, { useEffect, useState } from 'react'
import { elapsedTime } from '../../../common/howDate';
import dayjs from 'dayjs';

const NotificationBar = () => {

  // 시간 불러오는 부분
  let toDate = new dayjs().format('YYYY-MM-DD');
  let toTime = new dayjs().format('YYYY-MM-DD HH:mm:ss')

  const minusDate = (number)=>{
    const now = new dayjs().subtract(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const plusDate = (number)=>{
    const now = new dayjs().add(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const toDay = {
    date: toDate,
    time: toTime,
    minusDate,
    plusDate
  }

  const [selectRow, setSelectRow] = useState(-1);
  const [showText, setShowText] = useState(false);
  
  const [seeCount, setSeeCount] = useState(0);

  const userid = window.sessionStorage.getItem('basicID');
  const username = window.sessionStorage.getItem('basicName');

  // 게시판 조회를 몇번 했는지
  const SeeCount = async (no)=>{
    await Axios.get('/api/Notification/seecount', {
      params: { ID: no }
    })
    .then((res)=>{
      setSeeCount(res.data[0].VALUE);
    })
  };

  // 게시판 클릭시 읽음 처리
  const SeePost = async (no)=>{
    await Axios.post('/api/Notification/postsee', {
      Ino: no, ID: userid, Name: username, Date: toDay.time
    })
    .then((res)=>{
      // console.log(`${no}번 게시글 읽음 처리 성공`);
    })
  };
  
  const [notiflcaptionData, setNotiflcaptionData] = useState([]);

  useEffect(()=>{

    let Mount = true;

    // 알림 데이터 불러오기
    const NotificationData = async (value) => {
      await Axios.get(`/api/notification/data`, {
        params: { Type: value }
      })
      .then((res)=>{
        if(Mount)
        {
          setNotiflcaptionData(res.data);
        } else {
          setNotiflcaptionData([]);
        }
      });
    };
    NotificationData();
    
    return ()=>{
      Mount = false;
    }
  }, []);
    
  // 🔴🔕💡📣

  return (
    <div className='flex flex-col gap-3 bg-[#1E1E1E] p-3 rounded-md w-[500px] border-[2px] border-[#3E3E3E] shadow-lg shadow-[#2E2E2E] duration-150 cursor-default'>

      {/* 알림 */}
      <div className='border-b-[1px] border-[#2E2E2E] pb-3'>
        <p className='font-bold opacity-80 tracking-widest'>📣 알림</p>
      </div>

      {/* 알림 타이틀 */}
      <div className='flex flex-col duration-150 gap-3 min-h-80 max-h-80 overflow-y-auto overflow-x-hidden whitespace-normal'>
        {
          notiflcaptionData.length ?
          notiflcaptionData.map((item, idx)=>(
            <div key={idx} className={`${showText && selectRow === idx && 'bg-[#2E2E2E] rounded-md'} hover:bg-[#2E2E2E] p-3 hover:left-[50px] active:opacity-70 duration-150 cursor-pointer`}
            onClick={()=>{

              if(showText && selectRow === idx){
                setShowText(false);
              } else {
                setSelectRow(idx);
                setShowText(true);
                SeePost(item.no);
                SeeCount(item.no);
              }
              
            }}>
              <div className='flex justify-between'>
                <p className={`${selectRow === idx && 'cursor-default'}`}>{item.title.length > 25 ? item.title.substr(0, 25) + '...' : item.title}</p>
                <p className={`text-stone-500 text-sm ${elapsedTime(item.date) === '방금 전' && 'animate-pulse'}`}>{elapsedTime(item.date)}</p>
              </div>
              {
                showText && selectRow === idx &&
                <div className={`duration-150 ${selectRow === idx && 'bg-[#2E2E2E] p-3 mt-3 cursor-default'}`}>
                  {/* 본문 내용 */}
                  <p className='whitespace-normal text-stone-300'>{item.text}</p>

                  {/* 본문 하단 내용 */}
                  <div className='mt-5 flex justify-between items-center gap-3 border-t-[1px] border-[#3E3E3E] w-full duration-150'>

                    {/* 하단 타이틀 */}
                    <div className='mt-5'>
                      <p className='text-stone-400 text-sm'>해당 알림을 읽은 횟수</p>
                    </div>

                    {/* 하단 내용 */}
                    <div className='mt-5 text-stone-400 text-sm'>
                      <p>{seeCount} 회</p>
                    </div>

                  </div>
                </div>
              }              
            </div>
          ))
          :
          <div className='text-center py-5 text-stone-300'>
            <p>알림이 없습니다</p>
          </div>
        }
      </div>
    </div>
  )
};

export default NotificationBar